(() => {
  'use strict';
  function init(root) {
    if (root.dataset.hwReady) return;
    root.dataset.hwReady = 'true';
    // Keep this page's single email ask in its free portrait creation flow.
    // The inherited capture observer also controls Aria, so restore its hidden state.
    const capture = document.getElementById('lm-capture');
    if(capture) {
      const suppressCapture = () => {
        if(!capture.hidden) capture.hidden = true;
        if(capture.getAttribute('aria-hidden') !== 'true') capture.setAttribute('aria-hidden','true');
      };
      suppressCapture();
      const captureObserver = new MutationObserver(suppressCapture);
      captureObserver.observe(capture,{attributes:true,attributeFilter:['hidden','aria-hidden']});
      root._hwCaptureCleanup = () => captureObserver.disconnect();
    }
    const cards = [...root.querySelectorAll('[data-hw-card]')];
    const strings = JSON.parse(root.querySelector('[data-hw-i18n]').textContent);
    const keys = new Set(cards.map(card => card.dataset.key));
    const filters = [...root.querySelectorAll('[data-hw-filter]')];
    const search = root.querySelector('[data-hw-search]');
    const status = root.querySelector('[data-hw-status]');
    const empty = root.querySelector('[data-hw-empty]');
    const grid = root.querySelector('[data-hw-grid]');
    let family = 'all';
    let expanded = false;
    const swipeTools = root.querySelector('[data-hw-swipe-tools]');
    const previousStyles = root.querySelector('[data-hw-prev]');
    const nextStyles = root.querySelector('[data-hw-next]');
    const syncStyleArrows = () => {
      const end = Math.max(0, grid.scrollWidth - grid.clientWidth);
      previousStyles.disabled = grid.scrollLeft <= 2;
      nextStyles.disabled = grid.scrollLeft >= end - 2;
    };
    const slideStyles = direction => grid.scrollBy({left: direction * grid.clientWidth * .85, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    previousStyles.addEventListener('click', () => slideStyles(-1));
    nextStyles.addEventListener('click', () => slideStyles(1));
    grid.addEventListener('scroll', syncStyleArrows, {passive:true});
    grid.addEventListener('keydown', event => {
      if(event.target !== grid || expanded) return;
      if(event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();slideStyles(event.key === 'ArrowRight' ? 1 : -1);}
    });
    const styleResize = new ResizeObserver(syncStyleArrows);
    styleResize.observe(grid);
    const more = root.querySelector('[data-hw-more]');
    const moreWrap = root.querySelector('[data-hw-more-wrap]');
    const track = (event, fields) => {
      try { window.Shopify?.analytics?.publish?.(event, fields); } catch (_) {}
      root.dispatchEvent(new CustomEvent(event, {bubbles:true, detail:fields}));
    };
    const contextNames = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid','ttclid','preview_theme_id','lm_qa'];
    const params = new URLSearchParams(location.search);
    if(window.Shopify?.theme?.role === 'unpublished' && window.Shopify.theme.id) {
      params.set('preview_theme_id', String(window.Shopify.theme.id));
    }
    const mount = root.querySelector('[data-hw-generator-mount]');
    let generatorReady = false;
    let pendingStyle = null;
    const attachGenerator = () => {
      const generator = document.querySelector('[data-lm-generator-only]');
      if (!generator || !mount) return false;
      const section = generator.closest('.shopify-section') || generator;
      if (!mount.contains(section)) mount.append(section);
      return true;
    };
    if (mount) mount.hidden = true;
    const chooseStyle = (key) => {
      if (!keys.has(key)) return;
      if (!attachGenerator() || !generatorReady) { pendingStyle = key; return; }
      mount.hidden = false;
      root.dataset.hwCreating = 'true';
      if (dialog?.open) dialog.close();
      root.querySelector('[data-hw-mug-dialog]')?.close();
      try { sessionStorage.setItem('lm_collection','halloween'); } catch (_) {}
      const url = new URL(location.href);
      contextNames.forEach(name => { if(params.has(name)) url.searchParams.set(name, params.get(name)); });
      url.searchParams.set('style', key);
      url.searchParams.set('lm_collection', 'halloween');
      url.hash = 'hw-create';
      try { history.replaceState(history.state, '', url); } catch (_) {}
      document.dispatchEvent(new CustomEvent('lm:select-style', {detail:{styleKey:key}}));
    };
    const browseStyles = () => {
      root.dataset.hwCreating = 'false';
      const target = root.querySelector('.lmhw-collection');
      target.scrollIntoView({behavior:'instant',block:'start'});
      target.focus({preventScroll:true});
    };
    document.addEventListener('lm:choose-style', browseStyles);
    document.addEventListener('lm:generator-ready', () => {
      generatorReady = true;
      attachGenerator();
      if (pendingStyle) { const key=pendingStyle; pendingStyle=null; chooseStyle(key); }
    });
    const onReady = () => {
      // The section's inline initialization can run before this deferred asset.
      generatorReady = generatorReady || Boolean(document.querySelector('[data-lm-generator-only] #emailA'));
      attachGenerator();
      const key = params.get('style');
      if (keys.has(key) && (location.hash === '#hw-create' || params.get('lm_collection') === 'halloween')) chooseStyle(key);
      else if (location.hash === '#hw-create' || params.has('monster')) {
        if (mount) mount.hidden = false;
      }
      else if(location.hash === '#hw-styles') browseStyles();
    };
    const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g,' ').trim();
    const updateHref = link => {
      const base = link.getAttribute('href');
      if (!base || base.startsWith('#')) return;
      const url = new URL(base, location.href);
      if (url.origin !== location.origin && !root.hasAttribute('data-local-review')) return;
      if (!root.hasAttribute('data-local-review') && url.origin !== location.origin) return;
      contextNames.forEach(name => { if(params.has(name)) url.searchParams.set(name, params.get(name)); });
      link.href = url.href;
    };
    root.querySelectorAll('a[data-hw-context]').forEach(updateHref);
    root.querySelector('[data-hw-controls]').hidden = false;
    const apply = () => {
      const query = normalize(search.value);
      const tokens = query.split(' ').filter(Boolean);
      const matching = cards.filter(card => (family === 'all' || card.dataset.family === family) && tokens.every(token => normalize(card.dataset.search).includes(token)));
      const browsingAll = family === 'all' && !tokens.length;
      const visibleCards = matching;
      grid.dataset.expanded = String(expanded);
      const visibleSet = new Set(visibleCards);
      cards.forEach(card => { card.hidden = !visibleSet.has(card); });
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.hwFilter === family)));
      const message = matching.length === cards.length ? strings.all : strings.filtered;
      status.textContent = message.replace('__COUNT__',visibleCards.length).replace('__TOTAL__',cards.length);
      moreWrap.hidden = matching.length < 2;
      swipeTools.hidden = expanded || matching.length < 2;
      requestAnimationFrame(syncStyleArrows);
      more.setAttribute('aria-expanded',String(expanded));
      more.textContent = expanded ? strings.back_swipe : (browsingAll ? strings.expand_all_styles : strings.expand_styles).replace('__COUNT__', matching.length);
      empty.hidden = matching.length > 0;
    };
    filters.forEach(button => button.addEventListener('click', () => {
      family = button.dataset.hwFilter;
      grid.scrollLeft = 0;
      expanded = false;
      apply();
      track('lm_halloween_filter', {family});
    }));
    search.addEventListener('input', () => { expanded = false; grid.scrollLeft = 0; apply(); });
    more.addEventListener('click', () => {
      expanded = !expanded;
      apply();
      if(!expanded) {grid.scrollLeft = 0;root.querySelector('.lmhw-collection').scrollIntoView({behavior:'instant',block:'start'});}
      track('lm_halloween_catalog_expand', {expanded});
    });
    root.querySelector('[data-hw-reset]').addEventListener('click', () => {family = 'all';expanded = false;search.value = '';apply();search.focus();});
    root.querySelector('[data-hw-view]').addEventListener('click', event => {
      const large = grid.dataset.large !== 'true';
      grid.dataset.large = String(large);
      event.currentTarget.setAttribute('aria-pressed', String(large));
      event.currentTarget.textContent = large ? strings.compact : strings.large;
    });
    const dialog = root.querySelector('[data-hw-dialog]');
    const img = root.querySelector('[data-hw-dialog-img]');
    const title = root.querySelector('[data-hw-dialog-title]');
    const description = root.querySelector('[data-hw-dialog-description]');
    const dialogLink = root.querySelector('[data-hw-dialog-link]');
    let opener;
    if(typeof dialog.showModal === 'function') {
      cards.forEach(card => {
        const trigger = card.querySelector('[data-hw-zoom]');
        trigger.hidden = false;
        trigger.addEventListener('click', () => {
          const original = card.querySelector('img');
          title.textContent = card.querySelector('h3').textContent;
          description.textContent = card.querySelector('p').textContent;
          img.src = original.currentSrc || original.src;
          img.alt = original.alt;
          dialogLink.setAttribute('href',card.querySelector('[data-hw-style-link]').href);
          dialogLink.dataset.styleKey = card.dataset.key;
          dialogLink.setAttribute('aria-label',strings.create_in.replace('__NAME__',title.textContent));
          opener = trigger;
          dialog.showModal();
          root.dataset.hwDialogOpen = 'true';
          track('lm_halloween_style_view', {style_key:card.dataset.key});
        });
      });
      root.querySelector('[data-hw-dialog-close]').addEventListener('click',() => dialog.close());
      dialog.addEventListener('close', () => { delete root.dataset.hwDialogOpen; opener?.focus(); });
      dialog.addEventListener('click', event => {
        const rect = dialog.getBoundingClientRect();
        if(event.target === dialog && (event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom)) dialog.close();
      });
    }
    root.addEventListener('click', event => {
      const link = event.target.closest('a[data-style-key]');
      if(link && root.contains(link) && keys.has(link.dataset.styleKey)) {
        event.preventDefault();
        chooseStyle(link.dataset.styleKey);
        track('lm_halloween_create_click', {style_key:link.dataset.styleKey,placement:link.dataset.placement || 'portrait'});
      }
      const browse = event.target.closest('a[data-hw-browse]');
      if (browse && root.contains(browse)) { event.preventDefault(); browseStyles(); }
      // 2026-10-06: in-page links (e.g. Shop the whole collection) scroll explicitly; the native hash jump does not move this page.
      const jump = event.target.closest('a[href^="#"]');
      if (jump && !event.defaultPrevented && root.contains(jump)) {
        const id = jump.getAttribute('href').slice(1);
        const dest = id && document.getElementById(id);
        if (dest && dest.getClientRects().length) {
          event.preventDefault();
          dest.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
          try { history.replaceState(history.state, '', '#' + id); } catch (_) {}
        }
      }
    });
    const mugDialog = root.querySelector('[data-hw-mug-dialog]');
    if (mugDialog && typeof mugDialog.showModal === 'function') {
      let mugOpener;
      root.querySelectorAll('[data-hw-mug-preview]').forEach(button => button.addEventListener('click', () => {
        mugOpener = button;
        mugDialog.showModal();
        root.dataset.hwDialogOpen = 'true';
      }));
      root.querySelector('[data-hw-mug-close]').addEventListener('click', () => mugDialog.close());
      mugDialog.addEventListener('close', () => { delete root.dataset.hwDialogOpen; mugOpener?.focus(); });
    }
    const sticky = root.querySelector('[data-hw-sticky]');
    const heroAction = root.querySelector('[data-hw-hero-action]');
    if(sticky && 'IntersectionObserver' in window) {
      const visible = new Map();
      let passedHero = false;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          visible.set(entry.target, entry.isIntersecting);
          if(entry.target === heroAction) passedHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        });
        sticky.hidden = !passedHero || [...visible.values()].some(Boolean);
        root.dataset.hwStickyVisible = String(!sticky.hidden);
      }, {threshold:0});
      // 2026-10-06: guard so a missing element never stops the rest of init (Ask Aria wiring runs after this).
      [heroAction, root.querySelector('.lmhw-close .lmhw-cta')].forEach(el => { if(el) observer.observe(el); });
      root._hwObserver = observer;
    }
    const heroImage = root.querySelector('[data-hw-hero-image]');
    const heroCaption = root.querySelector('[data-hw-hero-caption]');
    const heroProduct = root.querySelector('[data-hw-hero-product]');
    const frameProductHref = heroProduct?.href;
    const heroThumbs = [...root.querySelectorAll('[data-hw-hero-thumb]')];
    heroThumbs.forEach(button => button.addEventListener('click', () => {
      heroImage.removeAttribute('srcset');
      heroImage.src = button.dataset.src;
      heroImage.alt = button.dataset.alt;
      heroCaption.textContent = button.dataset.caption;
      if (heroProduct) {
        const isPrint = button.dataset.src.includes('ghostmousers');
        const isPortrait = button.dataset.src.includes('lm-st-');
        heroProduct.href = isPrint ? '/products/premium-semi-glossy-paper-poster?lm_collection=halloween' : isPortrait ? '#hw-create' : frameProductHref;
        if(isPortrait) heroProduct.dataset.styleKey='madcatter';
        else delete heroProduct.dataset.styleKey;
        updateHref(heroProduct);
      }
      heroThumbs.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      track('lm_halloween_product_example', {view:button.textContent.trim()});
    }));
    // A small page-owned mobile launcher opens the single inherited support widget.
    // The vendor's expand event opens the panel; it does not start a call or send a message.
    const widget = document.getElementById('lmAriaWidget');
    const supportToggle = root.querySelector('[data-hw-support-toggle]');
    if(widget && window.matchMedia) {
      const mobile = window.matchMedia('(max-width: 899px)');
      const previousExpanded = widget.getAttribute('default-expanded');
      const closeSupport = () => {
        root.dataset.hwSupportOpen = 'false';
        supportToggle.setAttribute('aria-expanded','false');
        root.querySelectorAll('[data-hw-support-shortcut]').forEach(button => button.setAttribute('aria-expanded','false'));
        supportToggle.textContent = strings.support_open;
      };
      root.dataset.hwSupportReady = 'true';
      supportToggle.hidden = false;
      root.querySelectorAll('[data-hw-support-shortcut]').forEach(button => {
        button.hidden = false;
        button.setAttribute('aria-expanded','false');
        button.addEventListener('click', () => supportToggle.click());
      });
      supportToggle.addEventListener('click', () => {
        const open = root.dataset.hwSupportOpen !== 'true';
        root.dataset.hwSupportOpen = String(open);
        supportToggle.setAttribute('aria-expanded',String(open));
        root.querySelectorAll('[data-hw-support-shortcut]').forEach(button => button.setAttribute('aria-expanded',String(open)));
        supportToggle.textContent = open ? strings.support_close : strings.support_open;
        if(open) {
          widget.setAttribute('default-expanded','true');
          widget.dispatchEvent(new CustomEvent('elevenlabs-agent:expand',{bubbles:true,detail:{action:'expand'}}));
        }
      });
      mobile.addEventListener('change',closeSupport);
      root._hwSupportCleanup = () => {
        mobile.removeEventListener('change',closeSupport);
        if(previousExpanded === null) widget.removeAttribute('default-expanded');
        else widget.setAttribute('default-expanded',previousExpanded);
      };
    }
    apply();
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',onReady,{once:true});
    else onReady();
  }
  document.querySelectorAll('[data-hw-root]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-hw-root]').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-hw-root]').forEach(root => { root._hwObserver?.disconnect(); root._hwSupportCleanup?.(); root._hwCaptureCleanup?.(); }));
})();
